import { fromJS } from 'immutable';
import { handleActions } from 'redux-actions';

import {
  ORDER_SUBSCRIPTIONS,
  ORDER_SUBSCRIPTIONS_FINISHED,
} from './constants';

const initialState = fromJS({
  orderSubscriptionsFinished: null,
})

export const reducer = handleActions({
  [ORDER_SUBSCRIPTIONS]: (state) => (
    state
      .set('orderSubscriptionsFinished', false)
  ),

  [ORDER_SUBSCRIPTIONS_FINISHED]: (state) => (
    state
      .set('orderSubscriptionsFinished', true)
  ),


}, initialState);


export default reducer
